import { useQuery } from '@tanstack/react-query'

import type { AnnouncementObj } from '../../types/announcement'
import type { ApiResponse } from '../../types/api'
import { api } from '../../utils/api-client'
import { queryKeys } from './keys'

// One get_notice request shared by the announcement popup (useAnnouncements
// in the root route) and the homepage AnnouncementCarousel.
const useNotices = () => {
  return useQuery<AnnouncementObj[]>({
    queryKey: queryKeys.notices,
    queryFn: async ({ signal }) => {
      const res = await api.post<ApiResponse<AnnouncementObj[]>>(
        '/ajax_check.php',
        {
          type: 'get_notice',
          num: 10,
        },
        { signal },
      )
      return res.data.status === 1 ? res.data.info : []
    },
  })
}

export default useNotices
